(function () {
  'use strict';

  if (window.meVariantLabelTranslator) {
    window.meVariantLabelTranslator.refresh();
    return;
  }

  var pickerSelector = 'variant-selects[data-me-localize]';

  var languages = [
    'fr',
    'en',
    'nl',
    'de',
    'es',
    'da',
    'pt-pt',
    'it'
  ];

  var optionLabels = {
    color: [
      'Couleur',
      'Color',
      'Kleur',
      'Farbe',
      'Color',
      'Farve',
      'Cor',
      'Colore'
    ],
    size: [
      'Taille',
      'Size',
      'Maat',
      'Größe',
      'Talla',
      'Størrelse',
      'Tamanho',
      'Taglia'
    ]
  };

  var oneSizeLabels = [
    'Taille unique',
    'One size',
    'Eén maat',
    'Einheitsgröße',
    'Talla única',
    'One size',
    'Tamanho único',
    'Taglia unica'
  ];

  /*
   * Format :
   * clé|français|anglais|néerlandais|allemand|espagnol|
   * danois|portugais du Portugal|italien
   */
  var rows = [
    'white|Blanc|White|Wit|Weiß|Blanco|Hvid|Branco|Bianco',
    'black|Noir|Black|Zwart|Schwarz|Negro|Sort|Preto|Nero',
    'navy|Bleu marine|Navy|Marineblauw|Marineblau|Azul marino|Marineblå|Azul-marinho|Blu navy',
    'blue|Bleu|Blue|Blauw|Blau|Azul|Blå|Azul|Blu',
    'red|Rouge|Red|Rood|Rot|Rojo|Rød|Vermelho|Rosso',
    'pink|Rose|Pink|Roze|Rosa|Rosa|Lyserød|Rosa|Rosa',
    'beige|Beige|Beige|Beige|Beige|Beige|Beige|Bege|Beige',
    'brown|Marron|Brown|Bruin|Braun|Marrón|Brun|Castanho|Marrone',
    'grey|Gris|Grey|Grijs|Grau|Gris|Grå|Cinzento|Grigio',
    'green|Vert|Green|Groen|Grün|Verde|Grøn|Verde|Verde',
    'yellow|Jaune|Yellow|Geel|Gelb|Amarillo|Gul|Amarelo|Giallo',
    'orange|Orange|Orange|Oranje|Orange|Naranja|Orange|Laranja|Arancione',
    'purple|Prune|Plum|Pruim|Pflaume|Ciruela|Blommefarvet|Ameixa|Prugna',
    'cream|Crème|Cream|Crème|Creme|Crema|Creme|Creme|Crema',
    'coral|Corail|Coral|Koraal|Koralle|Coral|Koral|Coral|Corallo',
    'khaki|Kaki|Khaki|Kaki|Khaki|Caqui|Khaki|Caqui|Kaki',
    'camel|Camel|Camel|Camel|Camel|Camel|Camel|Camel|Cammello',
    'ecru|Écru|Ecru|Ecru|Ecru|Crudo|Ecru|Cru|Ecrù',
    'turquoise|Turquoise|Turquoise|Turkoois|Türkis|Turquesa|Turkis|Turquesa|Turchese',
    'bordeaux|Bordeaux|Bordeaux|Bordeaux|Bordeaux|Burdeos|Bordeaux|Bordô|Bordeaux',
    'fuchsia|Fuchsia|Fuchsia|Fuchsia|Fuchsia|Fucsia|Fuchsia|Fúcsia|Fucsia',
    'lilac|Lilas|Lilac|Lila|Flieder|Lila|Syren|Lilás|Lilla',
    'gold|Doré|Gold|Goud|Gold|Dorado|Guld|Dourado|Dorato',
    'silver|Argenté|Silver|Zilver|Silber|Plateado|Sølv|Prateado|Argentato',
    'lightblue|Bleu clair|Light blue|Lichtblauw|Hellblau|Azul claro|Lyseblå|Azul-claro|Azzurro',
    'darkgreen|Vert foncé|Dark green|Donkergroen|Dunkelgrün|Verde oscuro|Mørkegrøn|Verde-escuro|Verde scuro',
    'lightpink|Rose clair|Light pink|Lichtroze|Hellrosa|Rosa claro|Lys rosa|Rosa-claro|Rosa chiaro',
    'hotpink|Rose vif|Hot pink|Felroze|Knallrosa|Rosa intenso|Pink|Rosa-vivo|Rosa acceso',
    'darkred|Rouge foncé|Dark red|Donkerrood|Dunkelrot|Rojo oscuro|Mørkerød|Vermelho-escuro|Rosso scuro',
    'burgundy|Bordeaux|Burgundy|Bordeaux|Burgunderrot|Burdeos|Burgunderrød|Bordô|Borgogna',
    'wine|Bordeaux|Wine|Wijnrood|Weinrot|Vino|Vinrød|Vinho|Vinaccia',
    'rust|Rouille|Rust|Roest|Rostrot|Óxido|Rustrød|Ferrugem|Ruggine',
    'terracotta|Terracotta|Terracotta|Terracotta|Terrakotta|Terracota|Terrakotta|Terracota|Terracotta',
    'taupe|Taupe|Taupe|Taupe|Taupe|Topo|Taupe|Taupe|Tortora',
    'sand|Sable|Sand|Zand|Sand|Arena|Sand|Areia|Sabbia',
    'ivory|Ivoire|Ivory|Ivoor|Elfenbein|Marfil|Elfenben|Marfim|Avorio',
    'mint|Menthe|Mint|Munt|Mint|Menta|Mintgrøn|Verde-menta|Verde menta',
    'sage|Sauge|Sage|Salie|Salbei|Salvia|Salviegrøn|Verde-sálvia|Verde salvia',
    'olive|Olive|Olive|Olijf|Olivgrün|Oliva|Olivengrøn|Verde-azeitona|Verde oliva',
    'teal|Canard|Teal|Teal|Petrol|Azul verdoso|Petrol|Azul-petróleo|Verde petrolio',
    'cobalt|Cobalt|Cobalt|Kobalt|Kobaltblau|Azul cobalto|Koboltblå|Azul-cobalto|Blu cobalto',
    'lavender|Lavande|Lavender|Lavendel|Lavendel|Lavanda|Lavendel|Lavanda|Lavanda',
    'mauve|Mauve|Mauve|Mauve|Mauve|Malva|Mauve|Malva|Malva',
    'nude|Nude|Nude|Nude|Nude|Nude|Nude|Nude|Nude',
    'chocolate|Chocolat|Chocolate|Chocolade|Schokoladenbraun|Chocolate|Chokoladebrun|Chocolate|Cioccolato',
    'cognac|Cognac|Cognac|Cognac|Cognac|Coñac|Cognac|Conhaque|Cognac',
    'lightgrey|Gris clair|Light grey|Lichtgrijs|Hellgrau|Gris claro|Lysegrå|Cinzento-claro|Grigio chiaro',
    'darkgrey|Gris foncé|Dark grey|Donkergrijs|Dunkelgrau|Gris oscuro|Mørkegrå|Cinzento-escuro|Grigio scuro',
    'lightgreen|Vert clair|Light green|Lichtgroen|Hellgrün|Verde claro|Lysegrøn|Verde-claro|Verde chiaro',
    'darkblue|Bleu foncé|Dark blue|Donkerblauw|Dunkelblau|Azul oscuro|Mørkeblå|Azul-escuro|Blu scuro',
    'darkbrown|Marron foncé|Dark brown|Donkerbruin|Dunkelbraun|Marrón oscuro|Mørkebrun|Castanho-escuro|Marrone scuro',
    'lightbrown|Marron clair|Light brown|Lichtbruin|Hellbraun|Marrón claro|Lysebrun|Castanho-claro|Marrone chiaro',
    'darkpink|Rose foncé|Dark pink|Donkerroze|Dunkelrosa|Rosa oscuro|Mørk rosa|Rosa-escuro|Rosa scuro',
    'lightpurple|Violet clair|Light purple|Lichtpaars|Hellviolett|Violeta claro|Lys lilla|Violeta-claro|Viola chiaro',
    'darkpurple|Violet foncé|Dark purple|Donkerpaars|Dunkelviolett|Violeta oscuro|Mørk lilla|Violeta-escuro|Viola scuro',
    'lightyellow|Jaune clair|Light yellow|Lichtgeel|Hellgelb|Amarillo claro|Lysegul|Amarelo-claro|Giallo chiaro',
    'darkyellow|Jaune foncé|Dark yellow|Donkergeel|Dunkelgelb|Amarillo oscuro|Mørkegul|Amarelo-escuro|Giallo scuro',
    'lightorange|Orange clair|Light orange|Lichtoranje|Hellorange|Naranja claro|Lys orange|Laranja-claro|Arancione chiaro',
    'darkorange|Orange foncé|Dark orange|Donkeroranje|Dunkelorange|Naranja oscuro|Mørk orange|Laranja-escuro|Arancione scuro',
    'lightcoral|Corail clair|Light coral|Lichtkoraal|Hellkoralle|Coral claro|Lys koral|Coral-claro|Corallo chiaro',
    'offwhite|Blanc cassé|Off white|Gebroken wit|Gebrochenes Weiß|Blanco roto|Knækket hvid|Branco-sujo|Bianco sporco',
    'ecruwhite|Écru blanc|Ecru white|Ecru wit|Ecruweiß|Blanco crudo|Ecruhvid|Branco cru|Bianco ecrù',
    'warmwhite|Blanc chaud|Warm white|Warm wit|Warmweiß|Blanco cálido|Varm hvid|Branco quente|Bianco caldo',
    'electricblue|Bleu électrique|Electric blue|Elektrisch blauw|Elektroblau|Azul eléctrico|Elektrisk blå|Azul-elétrico|Blu elettrico',
    'royalblue|Bleu roi|Royal blue|Koningsblauw|Königsblau|Azul real|Kongeblå|Azul-real|Blu reale',
    'boisderose|Bois de rose|Rosewood|Rozenhout|Rosenholz|Palo de rosa|Rosentræ|Pau-rosa|Legno di rosa',
    'vieuxrose|Vieux rose|Old rose|Oud roze|Altrosa|Rosa viejo|Gammelrosa|Rosa-velho|Rosa antico',
    'vertdeau|Vert d’eau|Water green|Watergroen|Wassergrün|Verde agua|Vandgrøn|Verde-água|Verde acqua',
    'framboise|Framboise|Raspberry|Framboos|Himbeerrot|Frambuesa|Hindbærrød|Framboesa|Lampone',
    'cherryred|Rouge cerise|Cherry red|Kersenrood|Kirschrot|Rojo cereza|Kirsebærrød|Vermelho-cereja|Rosso ciliegia',
    'violet|Violet|Purple|Paars|Violett|Violeta|Lilla|Violeta|Viola'
  ];

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/ß/g, 'ss')
      .replace(/[\s'’_-]/g, '');
  }

  var colorLookup = Object.create(null);

  /*
   * Les clés explicites restent prioritaires.
   */
  rows.forEach(function (line) {
    var columns = line.split('|');
    colorLookup[normalize(columns[0])] = columns.slice(1);
  });

  rows.forEach(function (line) {
    var columns = line.split('|');
    var labels = columns.slice(1);

    labels.forEach(function (alias) {
      var key = normalize(alias);

      if (!colorLookup[key]) {
        colorLookup[key] = labels;
      }
    });
  });

  var aliases = {
    gray: 'grey',
    rose: 'pink',
    lila: 'lilac',
    lightgray: 'lightgrey',
    darkgray: 'darkgrey',
    navyblue: 'navy',
    bleuvert: 'teal',
    bleucanard: 'teal',
    cerise: 'cherryred',
    rougecerise: 'cherryred'
  };

  Object.keys(aliases).forEach(function (alias) {
    colorLookup[normalize(alias)] =
      colorLookup[normalize(aliases[alias])];
  });

  var oneSizeAliases = [
    'tu',
    'tailleunique',
    'onesize',
    'onesizefitsall',
    'eenmaat',
    'einheitsgrosse',
    'einheitsgroesse',
    'tallaunica',
    'uniquemaat',
    'onestørrelse',
    'onestorrelse',
    'tamanhounico',
    'tagliaunica'
  ];

  function languageIndex() {
    var fullLang = (document.documentElement.lang || 'fr')
      .toLowerCase()
      .replace(/_/g, '-');

    /*
     * Reconnaissance explicite de pt-PT.
     * "pt" utilise ici les libellés du Portugal.
     */
    var lang = fullLang === 'pt' ? 'pt-pt' : fullLang;
    var index = languages.indexOf(lang);

    if (index === -1 && fullLang.split('-')[0] !== 'pt') {
      index = languages.indexOf(fullLang.split('-')[0]);
    }

    return index === -1 ? 0 : index;
  }

  function optionKind(name) {
    var normalized = normalize(name);

    if (
      [
        'couleur',
        'color',
        'colour',
        'kleur',
        'farbe',
        'farve',
        'cor',
        'colore'
      ].indexOf(normalized) !== -1
    ) {
      return 'color';
    }

    if (
      [
        'taille',
        'size',
        'maat',
        'grosse',
        'groesse',
        'talla',
        'størrelse',
        'storrelse',
        'tamanho',
        'taglia'
      ].indexOf(normalized) !== -1
    ) {
      return 'size';
    }

    return '';
  }

  function translateValue(raw, kind, index) {
    var text = String(raw || '').trim();

    if (kind === 'size') {
      if (oneSizeAliases.indexOf(normalize(text)) !== -1) {
        return oneSizeLabels[index];
      }

      return text;
    }

    if (kind !== 'color') {
      return text;
    }

    return text.split('/').map(function (part) {
      var trimmed = part.trim();
      var labels = colorLookup[normalize(trimmed)];

      return labels ? labels[index] : trimmed;
    }).join('/');
  }

  function setText(element, text) {
    if (element && element.textContent !== text) {
      element.textContent = text;
    }
  }

  function translatePicker(picker, index) {
    picker.querySelectorAll('[data-me-option-name]').forEach(function (group) {
      var rawName = group.getAttribute('data-me-option-name');
      var kind = optionKind(rawName);
      var nameLabel = group.querySelector('[data-me-option-label]');

      setText(
        nameLabel,
        kind ? optionLabels[kind][index] : rawName
      );

      group.querySelectorAll('[data-me-variant-label]').forEach(function (label) {
        var raw = label.getAttribute('data-me-value');

        setText(label, translateValue(raw, kind, index));
      });

      group.querySelectorAll('option[data-me-value]').forEach(function (option) {
        var raw = option.getAttribute('data-me-value');
        var text = translateValue(raw, kind, index);
        var template = option.getAttribute('data-me-unavailable-template');

        if (template) {
          text = template.replace('__ME_VALUE__', text);
        }

        setText(option, text);
      });

      if (kind === 'color') {
        var selected = group.querySelector(
          '[data-selected-value]:not(.dropdown-swatch)'
        );

        var checked = group.querySelector(
          'input[type="radio"]:checked'
        );

        if (selected && checked) {
          setText(
            selected,
            translateValue(checked.value, kind, index)
          );
        }

        group.querySelectorAll('label[for]').forEach(function (label) {
          var input = document.getElementById(label.htmlFor);

          if (input && picker.contains(input)) {
            var translated = translateValue(
              input.value,
              kind,
              index
            );

            if (label.getAttribute('title') !== translated) {
              label.setAttribute('title', translated);
            }
          }
        });
      }
    });
  }

  var queued = false;
  var initialized = false;

  function refresh() {
    var index = languageIndex();

    document.querySelectorAll(pickerSelector).forEach(function (picker) {
      translatePicker(picker, index);
    });
  }

  function schedule() {
    if (queued) return;

    queued = true;

    requestAnimationFrame(function () {
      queued = false;
      refresh();
    });
  }

  function touchesPicker(node) {
    if (node.nodeType === 3) {
      node = node.parentElement;
    }

    if (!node || node.nodeType !== 1) {
      return false;
    }

    return Boolean(
      node.matches(pickerSelector) ||
      node.closest(pickerSelector) ||
      node.querySelector(pickerSelector)
    );
  }

  function init() {
    if (initialized) return;
    initialized = true;

    refresh();

    var observer = new MutationObserver(function (records) {
      var relevant = records.some(function (record) {
        if (touchesPicker(record.target)) {
          return true;
        }

        return Array.from(record.addedNodes).some(touchesPicker);
      });

      if (relevant) {
        schedule();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    document.addEventListener('change', function (event) {
      if (
        event.target.closest &&
        event.target.closest(pickerSelector)
      ) {
        schedule();
      }
    });

    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('pageshow', schedule);
  }

  window.meVariantLabelTranslator = {
    refresh: schedule
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {
      once: true
    });
  } else {
    init();
  }
})();
